import { eventSender } from 'Lib/event-sender/event-sender';

$('body').on('click', '.book-marketplace__item', function () {
    const $th = $(this);

    eventSender.clickYM($th.attr('data-ym'), $th.attr('href'));
});